import React, { useEffect, useState } from 'react';
import "./CustomRequest.css";
import Header from '../../components/Header';
import useAuth from "../../../customHooks/useAuth.js";
import { useLocation,useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance.js';
import { getCurrentUser } from '../../../common/currentUser';
import Dropdown from "../../components/Dropdown/Dropdown";


export default function CustomRequest() {


    const location = useLocation();
    const navigate = useNavigate();
    
    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");

    const bookingId = location.state?.bookingId || "";
    const hotelId = location.state?.hotelId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";
    const booking_code = location.state?.booking_code || "";


    // console.log("Booking Id :",bookingId);
    // console.log("hotelId Id :",hotelId);
    // console.log("Booked Rooms : ",bookedRooms);

    // Refresh Handle 
    useAuth();

    // Check Ids
    useEffect(()=>{
        const checkId = ()=>{
            if(bookingId==="" || hotelId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[bookingId,hotelId,navigate]);


    // State for storing validation errors
    const [errors, setErrors] = useState({});

    // Loader
    const [isLoading,setIsLoading] = useState(false);

    // Form Data
    const [formData,setFormData] = useState({
        comment : "",
        room : ""
    });

    // Handle Change
    const handleChange = (e)=>{
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        validateField(name, value);
    }

    // Form Validation in submiting
    const validateForm = ()=>{
        
        const newErrors = {};

        if(!formData.comment.trim()){
            newErrors.comment = "Please Enter Request Details";
        }
        if(!formData.room.trim()){
            newErrors.room = "Please Select Room";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    }

    // Form Validation in Validate Field
    const validateField = (field,value) => {

        const newErrors = { ...errors };

        switch(field){
            case "comment":
                if(!value.trim()){
                    newErrors.comment = "Please Enter Request Details";
                }
                else{
                    newErrors.comment ="";
                }
                break;

            case "room":
                if(!value.trim()){
                    newErrors.room = "Please Select The Room";
                }
                else{
                    newErrors.room = "";
                }
                break;

            default:
                break;
        }
        setErrors(newErrors);
    }

    // Handle Submit
    const handleSubmit = async()=>{
        try{
            if(!validateForm()){
                // console.log("Please Enter Correct Details in Form !");
                return;
            }
            
            // console.log("Booked ROoms : ",bookedRooms);
            setIsLoading(true);
            const currentUser = await getCurrentUser();
 
            function findMatchedRooms(bookedRooms, usersData) {
                const contact = usersData.contact;
                const matchedRooms = bookedRooms.filter((room)=>{
                    // Check if guests are null or an empty array, and skip the room if true
                    if (!room.guests || room.guests.length === 0) {
                        return false; // Skip this room
                    }
                    const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                    if(matchedGuest) {
                        return true; //
                    }
                    else{
                        return false;
                    }
                });
                return matchedRooms;
            }        

            const usersData = currentUser;  
            const matchedRooms = findMatchedRooms(bookedRooms, usersData);

            if(matchedRooms.length<=0){
                // console.log("Booking is not Present ");
                return;
            }
            // console.log("MAtched Rooms : " + matchedRooms[0].id);



            try{
                const roomData = bookedRooms.find(item=>item.id===formData.room);
                // console.log("Room Number : ",roomData.room_number);

                const passData = {
                    request_details: formData.comment,
                    service_room : roomData.room_number
                };
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/custom-request/`,passData);
                
                // console.log("Request Added : ",response.data);

                toast.success("Custom Request Created Successfully");
                navigate("/bookings",{state : {activeRequests : "requests"}});
            }catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error);
            }
        
        }catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }


  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className='customRequest'>
            <Header title="Custom Request"
                hotelName = {hotelName}
                hotelAddress = {hotelAddress}
                checkInDate = {checkInDate}
                checkOutDate = {checkOutDate}
                status = {status}
                activeTab = {activeTab}
                hotelId = {hotelId}
                bookingId = {bookingId}
                movetoHotel = "movetoHotel"
                booking_code = {booking_code}
            />
            <div className='custom-data'>
                
                {/* Comment */}
                <div className='custom-fields'>
                    <div className='custom-name'>
                        <h4>Request Details</h4>
                    </div>
                    <div className='custom-inp'>
                        <textarea name='comment' rows='4' cols="10" value={formData.comment} onChange={handleChange} ></textarea>
                    </div>
                    {errors.comment && <span className="error-message">{errors.comment}</span>}
                </div>

                {/* Select Room */}
                <div className='custom-fields'>
                    <div className='custom-inpguests'>
                        <div className='customSelect'>
                            <Dropdown
                                name="room"
                                value={formData.room}
                                onChange={handleChange}
                                placeholder="Select a room"
                                options={bookedRooms
                                    .filter(room => room.room_number)
                                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
                            />
                        </div>
                        
                        <div className='custom-btn'>
                            <button onClick={handleSubmit} disabled={formData.comment==="" || formData.room===""} >Send Request</button>
                        </div>
                    </div>
                    {errors.room && <span className="error-message">{errors.room}</span>}
                </div>
            
            </div>
        </div>
    </>
  )
}
